export default __webpack_public_path__ + "static/media/IFW_SoftwareCHARTS-01.0685188c.png";